import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react';

import classes from './Alert.module.scss';

export const AlertVariant = {
    WARNING: 'warning',
    ERROR: 'error'
} as const;

type AlertVariant = (typeof AlertVariant)[keyof typeof AlertVariant];

interface AlertProps {
    icon?: IconProp;
    variant: AlertVariant;
    text?: string;
    children?: React.ReactNode;
    className?: string;
}

export const Alert: React.FC<AlertProps> = props => {
    const selectedVariant = props.variant || AlertVariant.WARNING;

    const text = props.text || props.children;

    return (
        <div
            className={clsx(classes.root, props.className, {
                [classes.warning]: selectedVariant === AlertVariant.WARNING,
                [classes.error]: selectedVariant === AlertVariant.ERROR
            })}
        >
            {props.icon && <FontAwesomeIcon icon={props.icon} className={classes.icon} />}
            <p>{text}</p>
        </div>
    );
};
